import React, { useState } from 'react';
import { ActivityIndicator, Alert, StyleSheet, Text } from 'react-native';
import { useRouter } from 'expo-router';
import { useTranslation } from 'react-i18next';
import '../../i18n';
import { useAuth } from '../../features/auth/useAuth';
import { Screen } from '../shared/Screen';
import { Heading, Subtitle } from '../shared/Typography';
import { TextField } from '../shared/TextField';
import { Button } from '../shared/Button';
import { colors, fonts, spacing } from '../theme';

export function PasswordRecoveryScreen() {
  const { t } = useTranslation();
  const router = useRouter();
  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const { passwordReset, loading } = useAuth();

  const handleSubmit = async () => {
    setErrorMessage(null);
    setSuccessMessage(null);
    if (!email) {
      const msg = t('auth.passwordRecovery.requiredFieldMessage');
      setErrorMessage(msg);
      Alert.alert(t('auth.passwordRecovery.requiredFieldTitle'), msg);
      return;
    }
    try {
      await passwordReset(email);
      const msg = t('auth.passwordRecovery.successMessage');
      setSuccessMessage(msg);
      Alert.alert(
        t('auth.passwordRecovery.successTitle'),
        msg
      );
    } catch (error) {
      const msg = (error as Error).message;
      setErrorMessage(msg);
      Alert.alert(t('auth.passwordRecovery.errorTitle'), msg);
    }
  };

  return (
    <Screen>
      <Heading>{t('auth.passwordRecovery.title')}</Heading>
      <Subtitle>{t('auth.passwordRecovery.subtitle')}</Subtitle>
      <TextField
        placeholder={t('auth.passwordRecovery.emailPlaceholder')}
        value={email}
        onChangeText={(text) => {
          setEmail(text);
          setErrorMessage(null);
        }}
        autoCapitalize="none"
        keyboardType="email-address"
      />
      {errorMessage && <Text style={styles.errorText}>{errorMessage}</Text>}
      {successMessage && <Text style={styles.successText}>{successMessage}</Text>}
      {loading ? (
        <ActivityIndicator />
      ) : (
        <Button title={t('auth.passwordRecovery.submit')} onPress={handleSubmit} />
      )}
      <Button
        variant="ghost"
        title={t('auth.passwordRecovery.backToSignIn')}
        onPress={() => router.push('/(auth)/signin')}
      />
    </Screen>
  );
}

const styles = StyleSheet.create({
  errorText: {
    fontFamily: fonts.body,
    fontSize: 14,
    color: colors.clay,
    marginBottom: spacing.sm,
    textAlign: 'center',
  },
  successText: {
    fontFamily: fonts.bodyBold,
    fontSize: 14,
    color: colors.sageDeep,
    marginBottom: spacing.sm,
    textAlign: 'center',
  },
});